import './RestaurantInfoShimmer.scss'

function RestaurantInfoShimmer() {
  return (
    <div className='restaurant-info-shimmer'>
        <div className="box">
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
        <div className="box">
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
        <div className="box">
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
        <div className="box">
            <div className="line1"></div>
            <div className="line2"></div>
        </div>
    </div>
  )
}

export default RestaurantInfoShimmer